import React from 'react';
import {r} from "@/utils/responsive";
import masterAvatar from "@/assets/img/master_avatar.png";
import masterCardBg from "@/assets/img/master_card_bg.png";
import bgCardVideo from "@/assets/video/bg_card_video.mp4";
import DisabledWrapper from "@/components/DisabledWrapper";
import ReactPlayerWrapper from "@/components/ReactPlayerWrapper";
import {S3_FILES} from "@/config/s3_files";

interface MasterBotCardProps extends React.HTMLAttributes<HTMLDivElement> {
}

const MasterBotCard: React.FC<MasterBotCardProps> = ({className, ...props}) => {
    return (
        <div
            {...props}
            style={{
                position: "relative",
                width: r.vmax(939),
                height: r.vmax(481),
                padding: `${r.vmax(153)} ${r.vmax(72)} 0`,
                color: '#ffffff',
                fontSize: r.vmax(28),
                lineHeight: r.vmax(36),
                whiteSpace: 'pre-wrap',
                marginTop: r.vmax(43),
            }}
        >
            {/* Невидимый SVG с определением clipPath */}
            <svg style={{position: 'absolute', width: 0, height: 0}}>
                <defs>
                    <clipPath id="card_video_mask_master" clipPathUnits="objectBoundingBox">
                        <path
                            d="M1 0.765C1 0.844 1 0.883 0.988 0.907C0.975 0.931 0.955 0.931 0.914 0.931H0.882C0.877 0.931 0.874 0.931 0.872 0.930C0.870 0.929 0.868 0.929 0.864 0.928L0.833 0.914C0.829 0.913 0.827 0.912 0.824 0.911C0.822 0.910 0.819 0.910 0.815 0.910H0.214C0.199 0.910 0.192 0.910 0.185 0.915C0.178 0.920 0.172 0.930 0.161 0.950L0.151 0.963C0.140 0.983 0.134 0.992 0.127 0.994C0.120 0.996 0.113 0.996 0.098 0.996H0.085C0.045 0.996 0.025 0.996 0.0125 0.975C0 0.954 0 0.912 0 0.833V0.212C0 0.134 0 0.094 0.0125 0.070C0.025 0.046 0.045 0.046 0.085 0.046H0.820C0.830 0.046 0.834 0.046 0.838 0.044C0.842 0.041 0.845 0.037 0.852 0.029L0.871 0.017C0.878 0.008 0.882 0.004 0.887 0.002C0.892 0 0.898 0 0.907 0H0.914C0.955 0 0.975 0 0.988 0.024C1 0.049 1 0.088 1 0.166L1 0.765Z"
                        />
                    </clipPath>
                </defs>
            </svg>

            <img style={{
                pointerEvents: 'none',
                position: 'absolute',
                zIndex: 2,
                left: r.vmax(-16),
                top: r.vmax(-96),
                width: r.vmax(276),
                height: r.vmax(284),
            }} alt="" src={S3_FILES.MASTER_CARD_AVATAR}/>
            <div style={{
                position: 'relative',
                zIndex: 2,
                display: 'flex',
                flexDirection: 'column',
                gap: r.vmax(20),
                letterSpacing: r.vmax(-0.20),
            }}>
                <p>{`MasterBot — даёт задания, чтобы восстановить \nпорядок. Мудрый, холодный, как etcd в \nпродакшене. Он знает, что происходит в каждом \nуголке кластера.`}</p>
                <p>{`Он — ваш проводник, ваш kube-controller-\nmanager в мире хаоса.`}</p>
            </div>
            <DisabledWrapper>
                <img src={S3_FILES.MASTER_CARD_BG} alt="" style={{
                    position: 'absolute',
                    inset: 0,
                    objectPosition: 'top',
                    objectFit: 'contain',
                    zIndex: 1,
                    opacity: .9
                }}/>

                <div style={{
                    position: 'absolute',
                    inset: 0,
                    clipPath: 'url(#card_video_mask_master)',
                }}>
                    <ReactPlayerWrapper videoSrc={S3_FILES.CHARACTER_CARD_BG_VIDEO}
                                        posterSrc={S3_FILES.CHARACTER_CARD_BG_VIDEO_POSTER} style={{

                        clipPath: 'url(#card_video_mask_master)',
                    }}/>
                </div>
            </DisabledWrapper>
        </div>
    );
};

export default MasterBotCard;
